<template>
  <div>
    <vs-button
      class="mx-2 mt-1"
      color="primary"
      type="filled"
      icon-pack="feather"
      icon="icon-upload"
      @click="open"
      >Cargar Factura
    </vs-button>
    <vs-popup-custom
      classContent="popup-example"
      :title="title"
      :persistent="disableClose"
      :active.sync="popupActivo"
    >
      <upload-expense-files ref="expenseFiles" @update="updateFiles" class="mb-4" />
      <div class="flex flex-wrap">
        <div class="w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3 ml-auto mr-auto">
          <vs-button
            type="filled"
            color="danger"
            class="w-full mx-4"
            :disabled="!expenseFiles.status"
            icon-pack="feather"
            icon="icon-send"
            @click="createExpense"
          >
            Enviar
          </vs-button>
        </div>
      </div>
    </vs-popup-custom>
  </div>
</template>

<script>
import UploadExpenseFiles from './UploadExpenseFiles.vue'
import VsPopupCustom from '@/components/modals/VsPopupCustom.vue'
import vendor from '@/http/requests/vendor/index.js'
export default {
  components: {
    UploadExpenseFiles,
    VsPopupCustom,
  },
  data() {
    return {
      expenseFiles: {
        status: false,
        files: {
          xml: null,
          pdf: null,
          others: [],
        },
      },
      title: 'Cargar Factura',
      popupActivo: false,
      disableClose: true,
    }
  },
  methods: {
    open() {
      this.popupActivo = true
      this.showAlert = false
      this.$refs.expenseFiles.restart()
    },
    updateFiles(e) {
      this.expenseFiles = { ...e }
    },
    validateFiles:function(files){
      let size = 0
      if(files.pdf != null){
        size += files.pdf.size / (1024*1024)
      }
      if(files.xml != null){
        size += files.pdf.size / (1024*1024)
      }
      files.others.forEach(function (file, i) {
        size += file.size / (1024*1024)
      })
      if(size > 10){
        this.$vs.notify({
            color: 'warning',
            title: 'Alerta',
            text: 'Max. 10 MB.',
          })
        return false
      }
      return true
    },
    createExpense() {
    if(!this.validateFiles(this.expenseFiles.files)){
        return
    }
     this.$vs.loading()
      const data = new FormData()
      const vendorData = JSON.parse(localStorage.getItem('vendor'))
      data.append('vendor_id', vendorData.VendorId)
      data.append('xml', this.expenseFiles.files.xml)
      data.append('pdf', this.expenseFiles.files.pdf)
      this.expenseFiles.files.others.forEach(function (file, i) {
        data.append('other[]', file)
      })
      vendor
        .createExpense(data)
        .then((res) => {
          this.$vs.loading.close()
          if (res.data.status == true) {
            this.$vs.notify({
              color: 'success',
              title: 'Success',
              text: res.data.msg,
            })
            this.popupActivo = false
            this.$emit('success')
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Error',
              text: res.data.msg,
            })
          }
        })
        .catch((err) => {
          if (422 === err.response.status) {
            this.msg = err.response.data.msg
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Alert',
              text: 'SERVER ERROR',
            })
          }
          this.$vs.loading.close()
        })
    },
  },
}
</script>

<style>
@media (min-width: 992px) {
  .con-vs-popup .vs-popup {
    width: 70vw;
  }
}
</style>
